import { render, staticRenderFns } from "./ModalAssignAuto.vue?vue&type=template&id=04bb0052&scoped=true&"
import script from "./ModalAssignAuto.vue?vue&type=script&lang=js&"
export * from "./ModalAssignAuto.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssignAuto.vue?vue&type=style&index=0&id=04bb0052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb0052",
  null
  
)

export default component.exports